import { Load } from "../../../lib/model/Load";
import { ExtraType } from "../../../lib/model/ExtraType";
import { AddressState } from "../../../lib/model/AddressState";
import { TourType } from "../../../lib/model/TourType";

export type BookMultiOrder = Readonly<{
  type?: TourType;
  date?: string;
  singlePoint: BookPoint;
  multiPoints: BookPoint[];
  extras: ExtraType[];
  comment?: string;
  internalReference?: string;
  pickupComment?: string;
  dropoffComment?: string;
}>;

export type BookPoint = {
  address: AddressState;
  loads: Load[];
  timewindow: [number, number];
  comment?: string;
};

export enum StopType {
  Pickup = "PICKUP",
  Dropoff = "DROPOFF"
}
